import { z } from "zod";

export const GaExceptionsSchema = z.array(z.string());

export const GeneralAdmissionSchema = z.object({
  enabled: z.boolean(),
  data: GaExceptionsSchema,
});
